import React from "react";
import {
  Box,
  FormControlLabel,
  Stack,
  Switch,
  Typography,
} from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const OnOffSwitch = () => {
  return (
    <>
      <Box p={3}>
        <Typography variant={"h6"} color={"text.primary"}>
          Switch with Text (On/Off)
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          switch thumb inside switch track. with on/off text.
        </Typography>
      </Box>
      <Box sx={{ width: "80%", marginInline: " auto", p: 3 }}>
        <PreviewAndEditor
          title={"switch primary with On/Off text"}
          language={"js"}
          value={"      <FormControlLabel\n" +
              "              control={\n" +
              "                <Switch variant={\"onOff\"} color={\"primary\"} defaultChecked />\n" +
              "              }\n" +
              "              label=\"Medium On/Off Switch\"\n" +
              "            />\n\n\n" +
              "            <FormControlLabel\n" +
              "              control={\n" +
              "                <Switch\n" +
              "                  variant={\"onOff\"}\n" +
              "                  color={\"primary\"}\n" +
              "                  size={\"small\"}\n" +
              "                  defaultChecked\n" +
              "                />\n" +
              "              }\n" +
              "              label=\"Small On/Off Switch\"\n" +
              "            />"}
        >
          <Stack spacing={2}>
            <FormControlLabel
              control={
                <Switch variant={"onOff"} color={"primary"} defaultChecked />
              }
              label="Medium On/Off Switch"
            />
            <FormControlLabel
              control={
                <Switch
                  variant={"onOff"}
                  color={"primary"}
                  size={"small"}
                  defaultChecked
                />
              }
              label="Small On/Off Switch"
            />
          </Stack>
        </PreviewAndEditor>
      </Box>
    </>
  );
};

export default OnOffSwitch;
